module.exports = __webpack_public_path__ + "media/tags/mass-4-fc07cf4c.png";